import React, { Component } from 'react';
import { Grid, Row, Col, Alert } from 'react-bootstrap';

import Button from 'elements/CustomButton/CustomButton.jsx';

class Notifications extends Component {
    constructor(props) {
        super(props);
    
        this.handleClick = this.handleClick.bind(this);
    
        this.state = {
          pos: "",
          msg:""
        };
    }
    handleClick(pos,msg) {
       this.setState({ pos: pos, msg: msg });
    alert(pos + "  msg: "+msg);
    //   console.log('onclick: ' + pos);  
       return ( <Alert bsStyle="success">
                <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                <span><b> הצלחה - </b> הודעה רגילה עם bsStyle="success"</span>
            </Alert>);
    }
    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <div className="card">
                        <div className="header">
                            <h4 className="title">הודעות</h4>
                            <p className="category">קוד מקור פתוח <a target="_blank" rel="noopener noreferrer" href="https://github.com/igorprado">Igor Prado</a>. למידע נוסף <a href="http://igorprado.com/react-notification-system/" rel="noopener noreferrer" target="_blank">תיעוד מלא.</a></p>

                        </div>
                        <div className="content">
                            <Row>
                                <Col md={6}>
                                    <h5>עיצוב הודעות</h5>
                                    <Alert bsStyle="info">
                                        <span>זו הודעה ללא עיצוב מיוחד</span>
                                    </Alert>
                                    <Alert bsStyle="info">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span>הודעה עם כפתור סגירה.</span>
                                    </Alert>
                                    <Alert bsStyle="info" className="alert-with-icon">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span data-notify="icon" className="pe-7s-bell"></span>
                                        <span data-notify="message">הודעה עם כפתור סגירה וצלמית.</span>
                                    </Alert>
                                    <Alert bsStyle="info" className="alert-with-icon">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span data-notify="icon" className="pe-7s-bell"></span>
                                        <span data-notify="message">הודעה עם כפתור סגירה, צלמית ומספר שורות. You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don't have to worry about the style.</span>
                                    </Alert>
                                </Col>
                                <Col md={6}>
                                    <h5>הודעות עם סטטוס</h5>
                                    <Alert bsStyle="info">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span><b> מידע - </b> הודעה רגילה עם bsStyle="info"</span>
                                    </Alert>
                                    <Alert bsStyle="success">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span><b> הצלחה - </b> הודעה רגילה עם bsStyle="success"</span>
                                    </Alert>
                                    <Alert bsStyle="warning">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span><b> אזהרה - </b> הודעה רגילה עם bsStyle="warning"</span>
                                    </Alert>
                                    <Alert bsStyle="danger">
                                        <button type="button" aria-hidden="true" className="close">&#x2715;</button>
                                        <span><b> סכנה - </b> הודעה רגילה עם bsStyle="danger"</span>
                                    </Alert>
                                </Col>
                            </Row>
                            <br/>
                            <br/>
                            <div className="places-buttons">
                                <Row>
                                    <Col md={6} mdOffset={3} className="text-center">
                                        <h5>מיקום התראות
                                            <p className="category">לחץ על הכפתור לראות את מופע ההודעה</p>
                                        </h5>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2} mdOffset={3}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: tl','Top Left message')}>Top Left</Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: tc','Top Center message')}>Top Center</Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: tr','Top Right message')}>Top Right</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2} mdOffset={3}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: bl','Bottom Left message')}>Bottom Left</Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: bc','Bottom Center message')}>Bottom Center</Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button bsStyle="default" block onClick={() => this.handleClick('location: br','Bottom Right message')}>Bottom Right</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </Grid>
            </div>
        );
    }
}

export default Notifications;
